import { useNavigate } from 'react-router-dom';
import type { DashboardProjectDto } from '@aiai/shared';
import { Modal } from './Modal';

/** Small project picker for Start actions that need a project context. */
export function ProjectPickerModal({
  title,
  projects,
  open,
  onClose,
  hrefFor,
}: {
  title: string;
  projects: DashboardProjectDto[];
  open: boolean;
  onClose: () => void;
  hrefFor: (project: DashboardProjectDto) => string;
}) {
  const navigate = useNavigate();
  return (
    <Modal open={open} onClose={onClose} title={title} widthClass="max-w-sm">
      {projects.length === 0 ? (
        <p className="py-2 text-sm text-ink-muted">No projects yet — create one first.</p>
      ) : (
        <ul className="flex flex-col gap-1">
          {projects.map((p) => (
            <li key={p.id}>
              <button
                type="button"
                onClick={() => {
                  onClose();
                  navigate(hrefFor(p));
                }}
                className="flex w-full items-center justify-between gap-3 rounded-md px-2.5 py-2 text-left text-sm text-ink transition-colors hover:bg-surface-2"
              >
                <span className="min-w-0 flex-1 truncate">
                  {p.name}
                  <span className="ml-1.5 font-mono text-2xs text-ink-faint">/{p.workspace.slug}</span>
                </span>
                <span className="shrink-0 max-w-[10rem] truncate font-mono text-xs text-ink-faint">{p.repoFullName}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </Modal>
  );
}
